/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const justifyRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 15h11V9H4v6zM18.5 4v16H20V4h-1.5z" />
	</SVG>
);

export default justifyRight;
